import React, { useState, useEffect } from "react";
import { Spin, message } from "antd";
import { LoadingOutlined, HomeOutlined } from "@ant-design/icons";
import { Row, Col } from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import ZenGaugeMultiColor from "../Common/Graph/ZenGaugeMultiColor";
import ZenDonut from "../Common/Graph/ZenDonut";
import ZenHorBarChart from "../Common/Graph/ZenHorBarChart";
import Angela1C from "../Common/Angela/Angela1C";
import ZenVerBarChart from "../Common/Graph/ZenVerBarChart";

// Houdini_ImportData

const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

const boxShadow = "5px 5px 14px #181818,-5px -5px 14px #343434";

class EmsDashboardConsumption extends React.Component {
  state = {
    mainData: null,
    loading: true,
    loginError: false,
    selectedTab: null,
    lid: "all",
    tabsData: null,
    selectedMnt: "all",
    table: null,
    CurrentLoad: null,
    Generation: null,
    NetEnergy: null,
    PowerFactor: null,
    EnergySourceDist: null,
    DeptWiseConsumption: null,
    Grid: null,
    Solar: null,
    DG: null,
    Battery: null,
    ConsTrendHourly: null,
    ConsTrendMonthly: null,
    dataLoading: false,
    // Houdini_nullData
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("Energy Dashboard - Source");
    this._isMounted = true;
    this.fetchChartData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchChartData = (selectedTab = "all", lid = "all", mnt = "all") => {
    liracrypt
      .get("/chart/charttemplate", {
        lid,
        mnt,
        typ: "MainGraph",
        subTyp: selectedTab,
        chartGroup: "EmsEnergyConsumption",
      })
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["CurrentLoad"] = resp["data"]["CurrentLoad"];
        respData["Generation"] = resp["data"]["Generation"];
        respData["NetEnergy"] = resp["data"]["NetEnergy"];
        respData["PowerFactor"] = resp["data"]["PowerFactor"];
        respData["EnergySourceDist"] = resp["data"]["EnergySourceDist"];
        respData["DeptWiseConsumption"] = resp["data"]["DeptWiseConsumption"];
        respData["Grid"] = resp["data"]["Grid"];
        respData["Solar"] = resp["data"]["Solar"];
        respData["DG"] = resp["data"]["DG"];
        respData["Battery"] = resp["data"]["Battery"];
        respData["ConsTrendHourly"] = resp["data"]["ConsTrendHourly"];
        respData["ConsTrendMonthly"] = resp["data"]["ConsTrendMonthly"];

        // Houdini_RespData

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <>
          <SessionError visible={this.state.loginError} />
          <div
            style={{
              background: "#000000",
              paddingTop: 10,
              //   backgroundImage:
              //     "radial-gradient(circle, rgba(98,46,43,1) 0%, rgba(43,36,46,1) 50%, rgba(26,29,36,1) 100%)",
            }}
          >
            {this.state.loading === false ? (
              <div>
                <Col span={24}>
                  {this.state.mainData ? (
                    <div
                      style={{
                        margin: "10px",
                        padding: "10px",
                      }}
                    >
                      <div
                        style={{
                          color: "#bdc3c7",
                          fontSize: 28,
                          fontWeight: 400,
                          textAlign: "center",
                          margin: "0px 0px 30px 0px",
                        }}
                      >
                        Energy Dashboard
                      </div>

                      {/* ____________________________________START __________FORMAT________________TEMPLATE___________________*/}

                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                        <Col style={{ width: "20%" }}></Col>
                      </Row>

                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "50%" }}>
                          <Row style={{ background: "#000000" }}>
                            <Col style={{ width: "25%" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  background: "#191C24",
                                  border: "1px solid #3c3e4f",
                                  margin: "10px 10px 10px 10px",
                                }}
                              >
                                <ZenGaugeMultiColor
                                  divId={"CurrentLoad"}
                                  data={this.state.CurrentLoad.data}
                                  config={this.state.CurrentLoad.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </div>
                            </Col>

                            <Col style={{ width: "25%" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  background: "#191C24",
                                  border: "1px solid #3c3e4f",
                                  margin: "10px 10px 10px 10px",
                                }}
                              >
                                <ZenGaugeMultiColor
                                  divId={"Generation"}
                                  data={this.state.Generation.data}
                                  config={this.state.Generation.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </div>
                            </Col>

                            <Col style={{ width: "25%" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  background: "#191C24",
                                  border: "1px solid #3c3e4f",
                                  margin: "10px 10px 10px 10px",
                                }}
                              >
                                <ZenGaugeMultiColor
                                  divId={"NetEnergy"}
                                  data={this.state.NetEnergy.data}
                                  config={this.state.NetEnergy.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </div>
                            </Col>

                            <Col style={{ width: "25%" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  background: "#191C24",
                                  border: "1px solid #3c3e4f",
                                  margin: "10px 10px 10px 10px",
                                }}
                              >
                                <ZenGaugeMultiColor
                                  divId={"PowerFactor"}
                                  data={this.state.PowerFactor.data}
                                  config={this.state.PowerFactor.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </div>
                            </Col>
                          </Row>

                          {/* _______Row No 2________ */}
                          <Row style={{ background: "#000000" }}>
                            <Col style={{ width: "25%" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  background: "#191C24",
                                  border: "1px solid #3c3e4f",
                                  margin: "10px 10px 10px 10px",
                                }}
                              >
                                <Angela1C
                                  divId={"Grid"}
                                  data={this.state.Grid.data}
                                  config={this.state.Grid.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </div>
                            </Col>

                            <Col style={{ width: "25%" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  background: "#191C24",
                                  border: "1px solid #3c3e4f",
                                  margin: "10px 10px 10px 10px",
                                }}
                              >
                                <Angela1C
                                  divId={"Solar"}
                                  data={this.state.Solar.data}
                                  config={this.state.Solar.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </div>
                            </Col>

                            <Col style={{ width: "25%" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  background: "#191C24",
                                  border: "1px solid #3c3e4f",
                                  margin: "10px 10px 10px 10px",
                                }}
                              >
                                <Angela1C
                                  divId={"DG"}
                                  data={this.state.DG.data}
                                  config={this.state.DG.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </div>
                            </Col>

                            <Col style={{ width: "25%" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  background: "#191C24",
                                  border: "1px solid #3c3e4f",
                                  margin: "10px 10px 10px 10px",
                                }}
                              >
                                <Angela1C
                                  divId={"Battery"}
                                  data={this.state.Battery.data}
                                  config={this.state.Battery.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col style={{ width: "50%" }}>
                          <Row style={{ background: "#000000" }}>
                            <Col style={{ width: "40%" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  background: "#191C24",
                                  border: "1px solid #3c3e4f",
                                  margin: "10px 10px 10px 10px",
                                }}
                              >
                                <ZenDonut
                                  divId={"EnergySourceDist"}
                                  data={this.state.EnergySourceDist.data}
                                  config={this.state.EnergySourceDist.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </div>
                            </Col>

                            <Col style={{ width: "60%" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  background: "#191C24",
                                  border: "1px solid #3c3e4f",
                                  margin: "10px 10px 10px 10px",
                                }}
                              >
                                <ZenHorBarChart
                                  divId={"DeptWiseConsumption"}
                                  data={this.state.DeptWiseConsumption.data}
                                  config={this.state.DeptWiseConsumption.config}
                                  onChange={(data) =>
                                    this.changeBasicGraph(data)
                                  }
                                />
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>

                      <Row style={{ background: "#000000" }}>
                        <Col style={{ width: "50%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerBarChart
                              divId={"ConsTrendHourly"}
                              data={this.state.ConsTrendHourly.data}
                              config={this.state.ConsTrendHourly.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                        <Col style={{ width: "50%" }}>
                          <div
                            style={{
                              borderRadius: "10px",
                              background: "#191C24",
                              border: "1px solid #3c3e4f",
                              margin: "10px 10px 10px 10px",
                            }}
                          >
                            <ZenVerBarChart
                              divId={"ConsTrendMonthly"}
                              data={this.state.ConsTrendMonthly.data}
                              config={this.state.ConsTrendMonthly.config}
                              onChange={(data) => this.changeBasicGraph(data)}
                            />
                          </div>
                        </Col>
                      </Row>

                      {/* Houdini_DivData */}
                    </div>
                  ) : null}
                </Col>
              </div>
            ) : (
              <div className="Loading" style={{ minHeight: "100vh" }}>
                <Spin indicator={antIcon} />
              </div>
            )}
          </div>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}

export default EmsDashboardConsumption;
